import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa1, fa2, fa3, fa4 } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

//styles
import "./Learn.css";

export default function Learn({ showLearn }) {
  const navigate = useNavigate();
  const handleNext = () => {
    navigate("/tips");
  };
  return (
    <div className="learn">
      <h3>What You Should Know</h3>
      <div className="learn-grid">
        <div className="learn-child">
          <FontAwesomeIcon icon={fa1} className="learn-icon" size="3x" />
          <p className="learn-header">Order Online, Local Pickup</p>
          <p className="learn-paragraph">
            We're a small-town, family-owned business. You place your orders
            online and pick them up in Parsons or one of our community drop
            locations.
          </p>
        </div>
        <div className="learn-child">
          <FontAwesomeIcon icon={fa2} className="learn-icon" size="3x" />
          <p className="learn-header">Our Specialty</p>
          <p className="learn-paragraph learn-justify">
            We sell groceries by the case at discounted prices. Our groceries
            come from vendors specializing in manufacturer closeouts, overruns,
            and distressed, past-date or close-to-date items. This allows us to
            provide affordable, wholesome food to our customers, reducing their
            food budgets without sacrificing a nutritious diet.{" "}
          </p>
        </div>
        <div className="learn-child">
          <FontAwesomeIcon icon={fa3} className="learn-icon" size="3x" />
          <p className="learn-header">Changing Inventory</p>
          <p className="learn-paragraph learn-justify">
            {" "}
            Our inventory changes frequently, so if you see something you like,
            be sure to act quickly! You can continue to add to your order until
            the order window closes. We're adding new items everyday, so be sure
            to check back often!{" "}
          </p>
        </div>
        <div className="learn-child">
          <FontAwesomeIcon icon={fa4} className="learn-icon" size="3x" />
          <p className="learn-header">Monthly Pickup Date</p>
          <p className="learn-paragraph">
            When you place your order, you'll select a pickup date. This pick-up
            date is usually 2-5 weeks out depending on your location.{" "}
          </p>
        </div>
      </div>
      <button className="button learn-button" onClick={handleNext}>
        {!showLearn ? "Understanding our Product Cards" : "Next"}
      </button>
    </div>
  );
}
